const STORAGE_KEY = 'hcen_ip_user';
const TOKEN_KEY = 'hcen_ip_token';

const SESSION_MS = 365 * 24 * 60 * 60 * 1000; // 1 year — stay signed in like OP

function base64UrlDecode(part) {
  let s = part.replace(/-/g, '+').replace(/_/g, '/');
  const pad = s.length % 4;
  if (pad) s += '='.repeat(4 - pad);
  return atob(s);
}

function decodeCustomToken(token) {
  const parts = token.split('.');
  if (parts.length !== 2) return null;
  try {
    return JSON.parse(base64UrlDecode(parts[0]));
  } catch {
    return null;
  }
}

/** True if a staff token exists and is not expired. */
export function hasValidStaffSession() {
  const token = localStorage.getItem(TOKEN_KEY);
  const user = localStorage.getItem(STORAGE_KEY);
  if (!token || !user) return false;

  const parts = token.split('.');
  if (parts.length === 2) {
    const data = decodeCustomToken(token);
    if (!data || data.portal !== 'networks') return false;
    if (data.exp && Date.now() > data.exp) return false;
    return true;
  }

  // Cognito JWT — API verifies; check exp in payload if present
  if (parts.length === 3) {
    try {
      const payload = JSON.parse(base64UrlDecode(parts[1]));
      if (payload.exp && Date.now() > payload.exp * 1000) return false;
      return true;
    } catch {
      return true;
    }
  }
  return false;
}

export function clearStaffSession() {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(TOKEN_KEY);
}

let logoutInProgress = false;

/** Sign out staff only when explicitly requested — never auto-redirect mid-page. */
export function redirectToStaffLogin() {
  if (logoutInProgress) return;
  if (!localStorage.getItem(TOKEN_KEY)) return;
  logoutInProgress = true;
  clearStaffSession();
  const onLogin = window.location.pathname.startsWith('/login');
  if (!onLogin) window.location.assign('/login');
}

export function getSessionExpiryMs() {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) return 0;
  const parts = token.split('.');
  if (parts.length === 2) {
    const data = decodeCustomToken(token);
    return data?.exp || 0;
  }
  if (parts.length === 3) {
    try {
      const payload = JSON.parse(base64UrlDecode(parts[1]));
      return payload.exp ? payload.exp * 1000 : 0;
    } catch {
      return 0;
    }
  }
  return 0;
}

export { STORAGE_KEY, TOKEN_KEY, SESSION_MS };
